import React from "react";
import { Col, Input, Label, Row } from "reactstrap";
import { AsyncPaginatedSelect } from "components/common/AsyncPaginatedSelect";
import { getMaterialOptions } from "features/Materials/services/MaterialService";
import { getUserOptionsWithEmployeeProfile } from "features/Users/services/UserService";
import {
  EmployeeOption,
  EmployeeSingleValue,
} from "features/Employees/components/EmployeeSelectComponents";
import {
  MaterialInOutSourceType,
  MaterialInOutSourceTypeLabel,
} from "features/MaterialInOuts/constants/material-in-out.constants";

export type MaterialInOutListFiltersProps = {
  outstandingOnly: boolean;
  onOutstandingOnlyChange: (value: boolean) => void;
  sourceType: MaterialInOutSourceType | "";
  onSourceTypeChange: (value: MaterialInOutSourceType | "") => void;
  materialId: number | null;
  materialOption?: { value: number; label: string };
  onMaterialChange: (
    id: number | null,
    option?: { value: number; label: string },
  ) => void;
  userId: number | null;
  userOption?: { value: number; label: string };
  onUserChange: (
    id: number | null,
    option?: { value: number; label: string },
  ) => void;
};

export default function MaterialInOutListFilters({
  outstandingOnly,
  onOutstandingOnlyChange,
  sourceType,
  onSourceTypeChange,
  materialId,
  materialOption,
  onMaterialChange,
  userId,
  userOption,
  onUserChange,
}: MaterialInOutListFiltersProps) {
  return (
    <Row className="g-2 g-md-3 align-items-end flex-grow-1 w-100 mb-0">
      <Col xs={12} sm={6} md={4} lg={3}>
        <Label className="form-label text-muted small mb-1">Source type</Label>
        <Input
          type="select"
          className="form-select"
          value={sourceType}
          onChange={(e) =>
            onSourceTypeChange(
              (e.target.value || "") as MaterialInOutSourceType | "",
            )
          }
        >
          <option value="">All types</option>
          {(Object.values(MaterialInOutSourceType) as MaterialInOutSourceType[]).map(
            (t) => (
              <option key={t} value={t}>
                {MaterialInOutSourceTypeLabel[t]}
              </option>
            ),
          )}
        </Input>
      </Col>

      <Col xs={12} sm={6} md={4} lg={3}>
        <Label className="form-label text-muted small mb-1">Material</Label>
        <AsyncPaginatedSelect
          fetchOptions={getMaterialOptions}
          placeholder="All materials"
          defaultOption={materialOption}
          value={materialId}
          onChange={(opt: any) =>
            onMaterialChange(
              opt && !Array.isArray(opt) ? Number(opt.value) : null,
              opt && !Array.isArray(opt)
                ? { value: opt.value, label: opt.label }
                : undefined,
            )
          }
        />
      </Col>

      <Col xs={12} sm={6} md={4} lg={3}>
        <Label className="form-label text-muted small mb-1">
          Concerned person
        </Label>
        <AsyncPaginatedSelect
          fetchOptions={getUserOptionsWithEmployeeProfile}
          components={{
            Option: EmployeeOption,
            SingleValue: EmployeeSingleValue,
          }}
          placeholder="All users"
          defaultOption={userOption}
          value={userId}
          onChange={(opt: any) => {
            const id =
              opt && !Array.isArray(opt) && opt.value != null
                ? Number(opt.value)
                : null;
            onUserChange(
              id,
              id != null ? { value: id, label: opt.label } : undefined,
            );
          }}
        />
      </Col>

      <Col xs={12} sm="auto">
        <div className="form-check form-switch mb-0 pb-2">
          <Input
            type="checkbox"
            className="form-check-input"
            id="mio-outstanding-only"
            checked={outstandingOnly}
            onChange={(e) => onOutstandingOnlyChange(e.target.checked)}
          />
          <Label className="form-check-label" for="mio-outstanding-only">
            Outstanding only
          </Label>
        </div>
      </Col>
    </Row>
  );
}
